import { useCopy } from '@/core/i18n';
import type { LegalPageId, LegalVersion } from '@nexa/content';

export interface VersionSwitcherProps {
  readonly versions: readonly LegalVersion[];
  readonly active: string;
  /** URL sinh từ `pathFor()` — KHÔNG khai chuỗi URL ở đây (contract §1.1). */
  readonly hrefFor: (id: LegalPageId) => string;
}

/**
 * Bộ chuyển phiên bản — tương ứng `main/src/lib/components/VersionSwitcher.svelte`.
 * Ẩn khi chỉ có một phiên bản, y như bản gốc (`versions.length > 1`).
 */
export function VersionSwitcher({ versions, active, hrefFor }: VersionSwitcherProps) {
  const copy = useCopy();
  const activeVersion = versions.find((v) => v.id === active);
  if (versions.length <= 1 || activeVersion === undefined) return null;

  const isCurrent = versions[0]?.id === active;

  return (
    <details className="version-switch">
      <summary>
        {copy.legal.versionLabel} {activeVersion.id} (
        {isCurrent ? copy.legal.versionCurrent : copy.legal.versionArchived})
      </summary>
      <ul>
        {versions.map((v) => (
          <li key={v.id}>
            <a href={hrefFor(v.pageId)} {...(v.id === active ? { 'aria-current': 'page' } : {})}>
              {v.id} — {v.effectiveDate}
              {v.id === versions[0]?.id ? ` · ${copy.legal.versionCurrent}` : null}
              {v.id !== versions[0]?.id && v.id === active
                ? ` · ${copy.legal.versionViewing}`
                : null}
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
}
